// store/authStore.js
import { create } from "zustand";
import { getBannerData } from "../api/home";
import { fetchContactInfoData, postQueryRequest } from "../api/contactInfo";

export const useContactStore = create((set, get) => ({
    loading: true,
    banner: null,
    contact: null,

    getBanner: async () => {
        try {
            set({ loading: true })
            const res = await getBannerData('contactUs')
            set({ loading: false, banner: res })
            return res
        } catch (error) {
            console.log("Error in checkAuth:", error);
            set({ authUser: null, hasTriedAuth: true });
            return false;
        } finally {
            set({ isCheckingAuth: false, hasTriedAuth: true });
        }
    },
    getContactInfo: async () => {
        try {
            set({ loading: true })
            const res = await fetchContactInfoData()
            set({ loading: false, contact: res })
            return res
        } catch (error) {
            console.log("Error in checkAuth:", error);
            set({ authUser: null, hasTriedAuth: true });
            return false;
        }
    },
    postQuery: async (formData) => {
        try {
            set({ loading: true })
            const res = await postQueryRequest(formData)
            set({ loading: false })
            return res
        } catch (error) {
            console.log("Error in checkAuth:", error);
            set({ authUser: null, hasTriedAuth: true });
            return false;
        } 
    }

}));
